<script setup lang="ts">
  import { computed } from 'vue';
  import { ChevronRight } from 'lucide-vue-next';
  import type { DocumentRevision } from '@/entities/Document';
  import {
    buildHomologationDetailPath,
    formatCollaboratorNameAndRegistration,
    formatInstantToPtBR,
  } from '@/shared/lib';

  const props = defineProps<{
    revision: DocumentRevision;
  }>();

  const document = computed(() => props.revision.document);

  // Cada natureza tem a sua rota de detalhe: o id sozinho nao diz de qual tabela o item veio.
  const detailRoute = computed(() =>
    buildHomologationDetailPath('/aprovacao', props.revision.id, document.value?.type)
  );

  const requestDateLabel = computed(() => formatInstantToPtBR(props.revision.createdAt));

  const titleLabel = computed(() => {
    const name = document.value?.name?.trim();
    return name || '-';
  });

  const revisionLabel = computed(() => {
    const rev = props.revision.revision;
    if (rev === null || rev === undefined) return '-';
    return String(rev).padStart(2, '0');
  });

  const elaborationLabel = computed(() =>
    formatCollaboratorNameAndRegistration(
      document.value?.user?.name,
      document.value?.user?.registrationNumber
    )
  );
</script>

<template>
  <tr class="table-row-hover border-t border-gray-02 transition-colors duration-300 ease-out">
    <td class="pl-6 py-4.5 pr-0">
      <div class="text-sm text-gray-07">
        {{ requestDateLabel }}
      </div>
    </td>
    <td class="pl-6 py-4.5 text-sm text-gray-07 text-left">
      {{ document?.prefix ?? '' }}
    </td>
    <td class="pl-6 py-4.5 text-sm text-gray-07 text-left">
      {{ titleLabel }}
    </td>
    <td class="pl-6 py-4.5 text-sm text-gray-07 text-left">
      {{ revisionLabel }}
    </td>
    <td class="pl-6 py-4.5 text-sm text-gray-07 text-left">
      {{ elaborationLabel }}
    </td>
    <td class="pl-2 pr-6 py-4.5 text-sm text-gray-07 text-right">
      <router-link
        :to="detailRoute"
        class="inline-flex items-center justify-end text-gray-07 hover:text-gray-09"
        aria-label="Abrir detalhe da aprovação"
      >
        <ChevronRight
          class="h-6 w-6 shrink-0"
          aria-hidden="true"
        />
      </router-link>
    </td>
  </tr>
</template>
